import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LagDeviceBasicModel } from '@vi-iot/client/index';

@Component({
  selector: 'app-sequencing-strategy-tile',
  templateUrl: './sequencing-strategy-tile.component.html',
  styleUrls: ['./sequencing-strategy-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SequencingStrategyTileComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Input() isOn: boolean;
  @Input() isToggleEnabled = true;
  @Input() isCascadeList = false;
  @Input() lagDevices: LagDeviceBasicModel[];

  @Output() switchChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private translation: TranslateService) {}

  lagDevicesList: string;

  ngOnInit(): void {
    const lagName = this.translation.instant(
      '+INSTALLATIONS.INSTALLATION.CASCADES.SEQUENCE_STRATEGY.LAG_DEVICE.NAME'
    );
    this.lagDevicesList = this.lagDevices?.map((device) => `${lagName} ${device.id}`).join(', ');
  }

  onChanged(change: any): void {
    this.switchChange.emit(change.checked);
  }
}
